import { fromJS, Map } from 'immutable';
import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

const initialState = Map();

export const licenseReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_LICENSE_DESCRIPTION: {
            return state.mergeDeep({
                extensionLicenses: listToMap(fromJS(action.data), (license) =>
                    license.get('name'),
                ),
            });
        }
        case Actions.RESULT_PBX_LICENSE: {
            return state.set('pbxLicense', fromJS(action.data));
        }
        default: {
            return state;
        }
    }
};

export default licenseReducer;
